import * as React from 'react'

export function DateAddedCell({ row }) {
  const savedCourse = row.original

  const dateAdded = new Date(savedCourse.dateAdded).toLocaleDateString()

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="text-normal line-clamp-1 font-bold">{dateAdded}</div>
    </div>
  )
}
